import * as Blockly from 'blockly';

/**
 * Module-level workspace reference. There is exactly one Blockly workspace in
 * the app; exposing it through a singleton keeps header actions, the AI panel
 * and the flash pipeline decoupled from React prop drilling.
 */

let workspace: Blockly.WorkspaceSvg | null = null;

export function setWorkspace(ws: Blockly.WorkspaceSvg | null): void {
  workspace = ws;
}

export function getWorkspace(): Blockly.WorkspaceSvg | null {
  return workspace;
}

export function requireWorkspace(): Blockly.WorkspaceSvg {
  if (!workspace) throw new Error('The block canvas is not ready yet.');
  return workspace;
}
